import * as React from 'react';
import { createContext, PropsWithChildren } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthSessionCookie } from '../hooks/useAuthSessionCookie';
import Loading from '../components/Loading';

export interface AuthContextState {
  isAuthenticated: boolean;
  isVerified: boolean;
  isMfaEnabled: boolean;
  isCookieAuthenticated: boolean;
  isAuth0Authenticated: boolean;
  isActive: boolean;
  user: any;
}

export const AuthContext = createContext<AuthContextState>({
  isAuthenticated: false,
  isVerified: false,
  isMfaEnabled: false,
  isAuth0Authenticated: false,
  isCookieAuthenticated: false,
  isActive: false,
  user: null,
});

export const UserContextProvider = ({ children }: PropsWithChildren) => {
  const { isSessionCookiePresent: isCookieAuthenticated } =
    useAuthSessionCookie();

  const {
    isLoading: isAuth0Loading,
    isAuthenticated: isAuth0Authenticated,
    user,
  } = useAuth0();

  const isAuthenticated = isAuth0Authenticated || isCookieAuthenticated;

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated: isAuthenticated,
        isVerified: false,
        isMfaEnabled: false,
        isAuth0Authenticated: false,
        isCookieAuthenticated: false,
        isActive: false,
        user,
      }}
    >
      {isAuth0Loading ? (
        <Loading heading="Loading" text="Please wait" />
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};
